<template>
  <div :class="applyClass">
    <component :is="variant" :class="textClass">
      <slot></slot>
    </component>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "h1",
      validator: (value) => ["h1", "h2", "h3", "h4", "h5"].includes(value),
    },
    customClass: {
      type: String,
      default: "text-black",
    },
  },
  computed: {
    applyClass() {
      return this.class;
    },
    textClass() {
      switch (this.variant) {
        case "h1":
          return "font-bold md:text-4xl text-2xl";
        case "h2":
          return "font-bold md:text-3xl text-xl";
        case "h3":
          return "font-medium  md:text-2xl text-lg";
        case "h4":
          return "font-normal md:text-lg text-base";
        case "h5":
          return "font-normal lg:text-base text-sm";
        default:
          return "";
      }
    },
  },
};
</script>
